export function meterToMilesHelper(meter: number): number {
  if (meter) {
    const metersInAMile = 1609.344;
    return meter / metersInAMile;
  }
  return meter;
}
